<template>
  <div v-if="editor" class="editor-site editor-wrapper">
    <!-- Bubble Menu -->
    <bubble-menu
        v-if="editor"
        :editor="editor"
        :tippy-options="{ duration: 10, maxWidth: 'none' }"
        :should-show="shouldShowTableMenu"
    >
      <div class="bubble-menu table-spec-menu">
        <!-- ВЕРХНЯЯ СТРОКА: Текстовое форматирование (Выделено в первую часть) -->
        <div class="menu-row text-actions">
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().toggleBold().run()"
              :disabled="!editor.can().chain().focus().toggleBold().run()"
              :class="{ 'is-active': editor.isActive('bold') }"
              title="Bold"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-bold"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 5h6a3.5 3.5 0 0 1 0 7h-6l0 -7" /><path d="M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" /></svg>
          </button>
          <!-- Italic -->
          <button
              @click="editor.chain().focus().toggleItalic().run()"
              :disabled="!editor.can().chain().focus().toggleItalic().run()"
              :class="{ 'is-active': editor.isActive('italic') }"
              title="Italic"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-italic"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 5l6 0" /><path d="M7 19l6 0" /><path d="M14 5l-4 14" /></svg>
          </button>
          <!-- Code -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().toggleCode().run()"
              :disabled="!editor.can().chain().focus().toggleCode().run()"
              :class="{ 'is-active': editor.isActive('code') }"
              title="Code"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-rosette-discount"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 15l6 -6" /><path d="M9 9.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0" fill="currentColor" /><path d="M14 14.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0" fill="currentColor" /><path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" /></svg>
          </button>
          <!-- Bullet list -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().toggleBulletList().run()"
              :disabled="!editor.can().chain().focus().toggleCode().run()"
              :class="{ 'is-active': editor.isActive('bulletList') }"
              title="Bullet list"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-list"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l11 0" /><path d="M9 12l11 0" /><path d="M9 18l11 0" /><path d="M5 6l0 .01" /><path d="M5 12l0 .01" /><path d="M5 18l0 .01" /></svg>
          </button>
          <!-- Ordered list -->
          <button
              @click="editor.chain().focus().toggleOrderedList().run()"
              :class="{ 'is-active': editor.isActive('orderedList') }"
              title="Ordered list"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-list-numbers"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 6h9" /><path d="M11 12h9" /><path d="M12 18h8" /><path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4" /><path d="M6 10v-6l-2 2" /></svg>
          </button>
          <!-- Blockquote -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().toggleBlockquote().run()"
              :disabled="!editor.can().chain().focus().toggleCode().run()"
              :class="{ 'is-active': editor.isActive('blockquote') }"
              title="Quote"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon-tabler icons-tabler-filled icon-tabler-quote"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z" /><path d="M18 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z" /></svg>
          </button>
          <!-- Link -->
          <button
              v-if="!isH2Active()"
              @click="$refs.linkMenu?.open()"
              :disabled="!editor.can().chain().focus().toggleCode().run()"
              :class="{ 'is-active': editor.isActive('link') }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-link"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 15l6 -6" /><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" /><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" /></svg>
          </button>

          <span class="inner-divider"></span>

          <!-- Undo -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().undo().run()"
              :disabled="!editor.can().chain().focus().undo().run()"
              title="Undo"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-arrow-back-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 14l-4 -4l4 -4" /><path d="M5 10h11a4 4 0 1 1 0 8h-1" /></svg>
          </button>
          <!-- Redo -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().redo().run()"
              :disabled="!editor.can().chain().focus().redo().run()"
              title="Redo"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-arrow-forward-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 14l4 -4l-4 -4" /><path d="M19 10h-11a4 4 0 1 0 0 8h1" /></svg>
          </button>
          <!-- Clear -->
          <button
              v-if="!isH2Active()"
              @click="editor.chain().focus().clearNodes().unsetAllMarks().run()"
              title="Clear formatting"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eraser"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3" /><path d="M18 13.3l-6.3 -6.3" /></svg>
          </button>
        </div>

        <div class="menu-row table-actions">
          <!-- СТОЛБЦЫ -->
          <div class="action-group">
            <!-- Добавить столбец справа -->
            <button @click="editor.chain().focus().addColumnAfter().run()" type="button" title="Добавить столбец справа" class="me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table-export"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" /><path d="M3 10h18" /><path d="M10 3v18" /><path d="M16 19h6" /><path d="M19 16l3 3l-3 3" /></svg>
            </button>

            <!-- Удалить столбец -->
            <button @click="editor.chain().focus().deleteColumn().run()" type="button" class="text-danger" title="Удалить текущий столбец">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10" /><path d="M3 10h18" /><path d="M10 3v18" /><path d="M16 19h6" /></svg>
            </button>
          </div>

          <span class="inner-divider"></span>

          <!-- СТРОКИ -->
          <div class="action-group">
            <!-- Добавить строку снизу -->
            <button @click="editor.chain().focus().addRowAfter().run()" type="button" title="Добавить строку снизу" class="me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table-import"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8" /><path d="M3 10h18" /><path d="M10 3v18" /><path d="M19 22v-6" /><path d="M22 19l-3 -3l-3 3" /></svg>
            </button>

            <!-- Удалить строку -->
            <button @click="editor.chain().focus().deleteRow().run()" type="button" class="text-danger" title="Удалить текущую строку">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table-minus"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10" /><path d="M3 10h18" /><path d="M10 3v18" /><path d="M16 19h6" /></svg>
            </button>
          </div>

          <span class="inner-divider"></span>

          <!-- ЯЧЕЙКИ -->
          <div class="action-group">
            <!-- Объединить ячейки -->
            <button @click="editor.chain().focus().mergeCells().run()" type="button" title="Объединить выделенные ячейки" class="me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-border-none"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 4l0 .01" /><path d="M8 4l0 .01" /><path d="M12 4l0 .01" /><path d="M16 4l0 .01" /><path d="M20 4l0 .01" /><path d="M4 8l0 .01" /><path d="M12 8l0 .01" /><path d="M20 8l0 .01" /><path d="M4 12l0 .01" /><path d="M8 12l0 .01" /><path d="M12 12l0 .01" /><path d="M16 12l0 .01" /><path d="M20 12l0 .01" /><path d="M4 16l0 .01" /><path d="M12 16l0 .01" /><path d="M20 16l0 .01" /><path d="M4 20l0 .01" /><path d="M8 20l0 .01" /><path d="M12 20l0 .01" /><path d="M16 20l0 .01" /><path d="M20 20l0 .01" /></svg>
            </button>

            <!-- Разъединить ячейки -->
            <button @click="editor.chain().focus().splitCell().run()" type="button" title="Разъединить ячейку обратно">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-border-all"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -12" /><path d="M4 12l16 0" /><path d="M12 4l0 16" /></svg>
            </button>
          </div>

          <span class="inner-divider"></span>

          <!-- Удалить всю таблицу -->
          <button @click="editor.chain().focus().deleteTable().run()" type="button" class="btn-delete" title="Удалить таблицу полностью">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
            </svg>
          </button>
        </div>
      </div>

    </bubble-menu>
    <bubble-menu
        :editor="editor"
        :tippy-options="{ duration: 10 }"
        :should-show="shouldShowTextMenu"
        v-show="!isH2Active()"
    >
      <div class="bubble-menu">
        <div>
        <!-- Bold -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().toggleBold().run()"
            :disabled="!editor.can().chain().focus().toggleBold().run()"
            :class="{ 'is-active': editor.isActive('bold') }"
            title="Bold"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-bold"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 5h6a3.5 3.5 0 0 1 0 7h-6l0 -7" /><path d="M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" /></svg>
        </button>
        <!-- Italic -->
        <button
            @click="editor.chain().focus().toggleItalic().run()"
            :disabled="!editor.can().chain().focus().toggleItalic().run()"
            :class="{ 'is-active': editor.isActive('italic') }"
            title="Italic"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-italic"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 5l6 0" /><path d="M7 19l6 0" /><path d="M14 5l-4 14" /></svg>
        </button>
        <!-- Code -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().toggleCode().run()"
            :disabled="!editor.can().chain().focus().toggleCode().run()"
            :class="{ 'is-active': editor.isActive('code') }"
            title="Code"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-rosette-discount"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 15l6 -6" /><path d="M9 9.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0" fill="currentColor" /><path d="M14 14.5a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0" fill="currentColor" /><path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" /></svg>
        </button>
        <!-- Bullet list -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().toggleBulletList().run()"
            :disabled="!editor.can().chain().focus().toggleCode().run()"
            :class="{ 'is-active': editor.isActive('bulletList') }"
            title="Bullet list"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-list"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 6l11 0" /><path d="M9 12l11 0" /><path d="M9 18l11 0" /><path d="M5 6l0 .01" /><path d="M5 12l0 .01" /><path d="M5 18l0 .01" /></svg>
        </button>
        <!-- Ordered list -->
        <button
            @click="editor.chain().focus().toggleOrderedList().run()"
            :class="{ 'is-active': editor.isActive('orderedList') }"
            title="Ordered list"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-list-numbers"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11 6h9" /><path d="M11 12h9" /><path d="M12 18h8" /><path d="M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4" /><path d="M6 10v-6l-2 2" /></svg>
        </button>
        <!-- Blockquote -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().toggleBlockquote().run()"
            :disabled="!editor.can().chain().focus().toggleCode().run()"
            :class="{ 'is-active': editor.isActive('blockquote') }"
            title="Quote"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon-tabler icons-tabler-filled icon-tabler-quote"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z" /><path d="M18 5a2 2 0 0 1 2 2v6c0 3.13 -1.65 5.193 -4.757 5.97a1 1 0 1 1 -.486 -1.94c2.227 -.557 3.243 -1.827 3.243 -4.03v-1h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 2 -2z" /></svg>
        </button>
        <!-- Link -->
        <button
            v-if="!isH2Active()"
            @click="$refs.linkMenu?.open()"
            :disabled="!editor.can().chain().focus().toggleCode().run()"
            :class="{ 'is-active': editor.isActive('link') }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-link"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 15l6 -6" /><path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" /><path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" /></svg>
        </button>
      </div>
      <div class="cancel">
        <!-- Undo -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().undo().run()"
            :disabled="!editor.can().chain().focus().undo().run()"
            title="Undo"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-arrow-back-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 14l-4 -4l4 -4" /><path d="M5 10h11a4 4 0 1 1 0 8h-1" /></svg>
        </button>
        <!-- Redo -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().redo().run()"
            :disabled="!editor.can().chain().focus().redo().run()"
            title="Redo"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-arrow-forward-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 14l4 -4l-4 -4" /><path d="M19 10h-11a4 4 0 1 0 0 8h1" /></svg>
        </button>
        <!-- Clear -->
        <button
            v-if="!isH2Active()"
            @click="editor.chain().focus().clearNodes().unsetAllMarks().run()"
            title="Clear formatting"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eraser"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3" /><path d="M18 13.3l-6.3 -6.3" /></svg>
        </button>
      </div>

      <!-- Меню ссылки -->
      <LinkBubbleMenu
          ref="linkMenu"
          :editor="editor"
      />
      </div>
    </bubble-menu>

    <floating-menu
        class="floating-menu-wrapper"
        :editor="editor"
        :should-show="shouldShowFloatingMenu"
    >
      <div class="floating-menu">
        <button
            @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
            :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
            title="Heading 2"
            class="h2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon-tabler icons-tabler-outline icon-tabler-h-2"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0" /><path d="M4 6v12" /><path d="M12 6v12" /><path d="M11 18h2" /><path d="M3 18h2" /><path d="M4 12h8" /><path d="M3 6h2" /><path d="M11 6h2" /></svg>
        </button>
        <button @click="insertImage">
          <svg width="24" height="24" viewBox="-0.5 0 19 19" xmlns="http://www.w3.org/2000/svg" class="image"><path d="M16.205 6.813v7.29a1.118 1.118 0 0 1-1.115 1.115H2.91a1.118 1.118 0 0 1-1.115-1.115v-7.29A1.118 1.118 0 0 1 2.91 5.698h2.902v-.365a1.118 1.118 0 0 1 1.115-1.115h4.146a1.118 1.118 0 0 1 1.115 1.115v.365h2.902a1.118 1.118 0 0 1 1.115 1.115zm-3.789 3.645A3.416 3.416 0 1 0 9 13.874a3.416 3.416 0 0 0 3.416-3.416zM10.627 8.83A2.301 2.301 0 1 1 9 8.157a2.286 2.286 0 0 1 1.627.674zm-.643-3.262a.558.558 0 1 0 .558-.557.558.558 0 0 0-.558.557z"/></svg>
        </button>
        <button
            @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()"
            title="Вставить таблицу"
            type="button"
            class="table-menu"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table-row"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14" /><path d="M9 3l-6 6" /><path d="M14 3l-7 7" /><path d="M19 3l-7 7" /><path d="M21 6l-4 4" /><path d="M3 10h18" /><path d="M10 10v11" /></svg>
        </button>
      </div>
    </floating-menu>

    <editor-content
        :editor="editor"
        class="tiptap"
    />
  </div>
  <div class="mb-3">
    <span :class="{'is-invalid': v$.content.$invalid && v$.content.$dirty}"></span>
    <div class="invalid-feedback" v-for="error of v$.content.$silentErrors" :key="error.$uid">
      {{ error.$message }}
    </div>
  </div>
</template>

<script setup>
import "./css/style.css"
import "./css/table.css"

import { ref, reactive, watch, onMounted, onBeforeUnmount, defineEmits } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { minLength } from '@vuelidate/validators'

import { Editor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import { BubbleMenu, FloatingMenu } from '@tiptap/vue-3/menus'
import Image from '@tiptap/extension-image'
import { ImageFigure } from './extensions/ImageFigure'
import { Figcaption } from './extensions/Figcaption'
import { NodeSelection } from 'prosemirror-state'
import { useImageHandler } from './composables/useImageUploader'
import LinkBubbleMenu from './LinkBubbleMenu.vue'
import { ImageLoader } from './extensions/ImageLoader'
import cfg from "@/services/Config"

import { Table } from '@tiptap/extension-table'
import { TableRow } from '@tiptap/extension-table-row'
import { TableHeader } from '@tiptap/extension-table-header'
import { TableCell } from '@tiptap/extension-table-cell'

const props = defineProps({
  content: {
    type: Object,
  },
  show_floating_menu: {
    type: Boolean,
  },
  show_bubble_menu: {
    type: Boolean,
  },
  validations: {
    type: Object,
  },
  entity_id: {
    type: [Number, String],
    required: true,
  },
})

const emit = defineEmits(["onChange"])

const content = ref(props.content)
const $externalResults = reactive({})
const fields = reactive({
  content: content.value,
})
const rules = {
  content: {
    minLength: minLength(0),
  },
}
const editor = ref(null)
const imageHandler = ref(null)
const linkMenu = ref(null)
const v$ = useVuelidate(rules, fields, { $externalResults })

const isH2Active = () => {
  return editor.value?.isActive('heading', { level: 2 })
}

function validate(fn) {
  v$.value.$clearExternalResults()
  return v$.value.$validate().then(() => {
    fn()
  })
}

/* methods */
const insertImage = () => {
  imageHandler.value.insertImage()
}

const shouldShowTableMenu = () => {
  return editor.value && editor.value.isActive('table')
}

const shouldShowTextMenu = ({ editor: ed, state }) => {
  // Используем глобальную переменную editor напрямую
  if (editor.value && editor.value.isActive('table')) {
    return false
  }

  if (!props.show_bubble_menu) {
    return false
  }

  const { selection } = state
  if (!selection) return false

  // ❌ не показываем для NodeSelection
  if (selection instanceof NodeSelection) return false

  const { $from } = selection
  if (!$from) return false

  // ❌ КЛЮЧЕВОЕ УСЛОВИЕ:
  // если курсор или выделение внутри figcaption — НЕ показываем bubble-menu
  for (let i = $from.depth; i > 0; i--) {
    if ($from.node(i).type.name === 'figcaption') {
      return false
    }
  }

  // ✅ дальше обычная логика
  if (!selection.empty) return true
  if (ed.isActive('link')) return true

  return false
}

const shouldShowFloatingMenu = ({ editor: ed, state }) => {
  if (!props.show_floating_menu) {
    return false
  }

  // 👇 ДОБАВЛЕНО: Скрывать меню, если курсор находится внутри таблицы
  if (ed && ed.isActive('table')) {
    return false
  }

  const { selection } = state

  if (!selection || selection.empty === undefined) return false
  if (ed.isActive('imageFigure')) return false
  if (!selection.empty) return false

  const $from = selection.$from
  if (!$from?.parent) return false
  if ($from.parent.type.name !== 'paragraph') return false

  return $from.parent.content.size === 0
}


onMounted(() => {
  editor.value = new Editor({
    extensions: [
      StarterKit,
      Link.configure({ openOnClick: false, HTMLAttributes:{rel: ""}}),
      Image.extend({
        addAttributes() {
          return {
            ...this.parent?.(),
            width: {
              default: null,
              renderHTML: () => ({}),
            },
            height: {
              default: null,
              renderHTML: () => ({}),
            },
          }
        },
      }),
      Figcaption,
      ImageFigure,
      ImageLoader,
      Table.configure({
        resizable: true, // Позволит менять ширину колонок мышкой
      }),
      TableRow,
      TableHeader,
      TableCell,
    ],
    content: content.value ?? '',
    editorProps: {
      transformPastedHTML(html) {
        const allowedTags = {
          br: [],
          p: [],
          em: [],
          strong: [],
          code: [],
          a: ['href', 'target'],
          h2: [],
          ul: [],
          ol: [],
          li: [],
          blockquote: [],
          figure: [],
          figcaption: [],
          img: ['src', 'alt'],
          table: [],
          tbody: [],
          thead: [],
          tr: [],
          td: [],
          th: [],
        }

        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        const cleanNode = (node) => {
          // текст — оставляем
          if (node.nodeType === Node.TEXT_NODE) {
            return node.cloneNode(true)
          }

          // не элемент — выкидываем
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return null
          }

          const tag = node.tagName.toLowerCase()

          // тег не разрешён — разворачиваем детей
          if (!allowedTags[tag]) {
            const fragment = document.createDocumentFragment()
            node.childNodes.forEach(child => {
              const clean = cleanNode(child)
              if (clean) fragment.appendChild(clean)
            })
            return fragment
          }

          // разрешённый тег
          const el = document.createElement(tag)

          // разрешённые атрибуты
          allowedTags[tag].forEach(attr => {
            if (node.hasAttribute(attr)) {
              el.setAttribute(attr, node.getAttribute(attr))
            }
          })

          // дети
          node.childNodes.forEach(child => {
            const clean = cleanNode(child)
            if (clean) el.appendChild(clean)
          })

          return el
        }

        const body = document.createElement('body')
        doc.body.childNodes.forEach(node => {
          const clean = cleanNode(node)
          if (clean) body.appendChild(clean)
        })

        let innerHTML = body.innerHTML

        return innerHTML
            // несколько br подряд → новый абзац
            .replace(/(<br\s*\/?>\s*){2,}/gi, '</p><p>')
            .replace(/\u00A0|&nbsp;/g, ' ')
            // одиночные br просто удаляем
            //.replace(/<br\s*\/?>/gi, '')
      },
      handleDOMEvents: {
        mousedown: (view, event) => {
          linkMenu.value?.onClick(event)
          return false
        },
      },
    },
    onUpdate({ editor }) {
      const json = editor.getJSON()

      content.value = json
      validate(() => {})
      emit("onChange", json)
    },
  })

  const urlPost = cfg._('base', 'api_url_post') + '/api/v1/hpanel/post/insert-image'

  imageHandler.value = useImageHandler(editor, urlPost, props.entity_id)
})

onBeforeUnmount(() => {
  if (!props.editor?.view) return
})

watch(
    () => props.validations,
    (val) => {
      validate(() => {
        if (val?.content !== undefined) {
          $externalResults.content = val['content'][0]
        }
      })
    }
)
</script>
